import { IStreamingCompletionResponse, StreamingCompletionResponse } from "../models/completion-response";
import { getChatAuthHeaders } from "./chat-auth-service";

export type ModelSummaryRequest = {
  model_name: string;
  model_type?: string;
  output_text: string;
  force?: boolean;
};

export class ModelSummaryService {
  private buildUrl(): string {
    return new URL("/chat/model-summary", window.location.origin).toString();
  }

  private buildDeleteUrl(modelName: string): string {
    const url = new URL("/chat/model-summary", window.location.origin);
    url.searchParams.set("model_name", modelName);
    return url.toString();
  }

  async generateSummary(
    payload: ModelSummaryRequest,
    signal?: AbortSignal
  ): Promise<IStreamingCompletionResponse> {
    const authHeaders = await getChatAuthHeaders();
    const response = await fetch(this.buildUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/event-stream",
        ...authHeaders,
      },
      body: JSON.stringify(payload),
      signal,
    });
    if (!response.ok) {
      const errorText = await response.text().catch(() => "Unknown error");
      throw new Error(`Model summary request failed: ${response.status} ${errorText}`);
    }

    return new StreamingCompletionResponse(response);
  }

  async deleteSummaryCache(modelName: string): Promise<void> {
    const authHeaders = await getChatAuthHeaders();
    const response = await fetch(this.buildDeleteUrl(modelName), {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        ...authHeaders,
      },
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => "Unknown error");
      throw new Error(`Model summary cache delete failed: ${response.status} ${errorText}`);
    }
  }
}
